import { INewMenuItems, SET_MENU_DATA } from '@r1-frontend/entities/stores/city/reducer';

import { IAction } from '@r1-frontend/shared/types/Redux';

export const setMenuData = (newMenuItems: INewMenuItems): IAction<typeof SET_MENU_DATA, INewMenuItems> => ({
    type: SET_MENU_DATA,
    payload: newMenuItems,
});
